import HeaderTabsContainer, { TabButton } from '@/header/HeaderTabsContainer';
import { CASINO_FAVORITE, FAVORITES_HISTORY, NIKE1_FAV, TURBO_LIVE_FAVORITES } from '@/routing/routes';
import React from 'react';
import useHeaderTabsScroll from '@/_hooks/useHeaderTabsScroll';

function FavoritesTabs({ active }) {
    const scrollElementRef = useHeaderTabsScroll();
    return (
        <HeaderTabsContainer>
            <TabButton
                route={NIKE1_FAV}
                i18nCode="nikeOne.all"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={TURBO_LIVE_FAVORITES}
                i18nCode="nikeOne.live"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={FAVORITES_HISTORY}
                i18nCode="dashboard.history"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
            <TabButton
                route={CASINO_FAVORITE}
                i18nCode="menu.casino"
                activeRoute={active}
                scrollElementRef={scrollElementRef}
            />
        </HeaderTabsContainer>
    );
}

export default FavoritesTabs;
